import React, { useState } from "react";
import { fr } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// Champ date au format français (valeur : AAAA-MM-JJ).
export default function FrDateField({ value, onChange, testid, placeholder = "jj/mm/aaaa", className = "" }) {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(`${value}T12:00:00`) : undefined;
  const year = new Date().getFullYear();
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`flex h-10 w-full items-center justify-between gap-1 rounded-xl bg-white px-2 text-left text-[13px] font-semibold normal-case street-border-thin ${className}`}>
          <span className={date ? "" : "text-foreground/40"}>{date ? date.toLocaleDateString("fr-FR") : placeholder}</span>
          <CalendarDays className="h-4 w-4 shrink-0 text-foreground/50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="z-[300] w-auto p-0" align="start">
        <Calendar mode="single" locale={fr} selected={date} defaultMonth={date} captionLayout="dropdown-buttons" fromYear={year - 30} toYear={year + 15}
          classNames={{ caption: "relative flex items-center justify-center px-8 pt-1", caption_label: "hidden", vhidden: "sr-only", caption_dropdowns: "flex gap-1", dropdown_icon: "hidden",
            dropdown: "cursor-pointer rounded-md bg-white px-1.5 py-0.5 text-[13px] font-bold capitalize street-border-thin" }}
          labels={{ labelMonthDropdown: () => "Mois", labelYearDropdown: () => "Année", labelNext: () => "Mois suivant", labelPrevious: () => "Mois précédent" }}
          onSelect={(d) => { onChange(d ? toIso(d) : ""); setOpen(false); }} initialFocus />
        {value && (
          <button type="button" onClick={() => { onChange(""); setOpen(false); }} className="w-full border-t py-2 text-[12px] font-black text-foreground/60" data-testid={`${testid}-clear`}>Effacer</button>
        )}
      </PopoverContent>
    </Popover>
  );
}
